import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HelpCenterView = () => {
  const { id } = useParams();
  const [helpCenterData, setHelpCenterData] = useState(null);

  useEffect(() => {
    // Fetch data for the specific help center item using the 'id' from the URL parameter
    fetch(`https://dayoffice24.it/api/help-center/detail/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data) {
          setHelpCenterData(data.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching help center item data:', error);
      });
  }, [id]);

  return (
    <div className="main_wrap">
      <Header />
      <div className="content-wrapper">
        <section className="property-details-wrap pt-100 pb-75">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-8">
                {helpCenterData ? (
                  <div className="property-details text-center">
                    <div className="row align-items-start">
                      <div className="col-md-12">
                        <div className="property-title">
                          <span className="help_tut">Help Tutorial</span>
                          <h2>{helpCenterData.title}</h2>
                          <ul className="property-metainfo list-style">
                            <li>
                              <i className="flaticon-square"></i>Help Center
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="property-img text-center">
                      <img src={helpCenterData.photo} alt="Image" />
                    </div>
                    <div className="property-desc text-center">
                      <p>{helpCenterData.description}</p>
                    </div>
                  </div>
                ) : (
                  <div>Loading...</div> // Show a loading message or render an alternative content while data is being fetched
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default HelpCenterView;
